import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import API from "../Context/api";

function ViewReceipt() {
  const { id } = useParams();
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch receipt data from the database
  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const response = await API.get(`/receipts/${id}`);
        console.log(response);
        setReceipt(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch receipt");
      } finally {
        setLoading(false);
      }
    };

    fetchReceipt();
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error)
    return <p className="text-center text-red-500 py-10">Error: {error}</p>;
  if (!receipt)
    return <p className="text-center text-gray-500 py-10">No receipt found</p>;

  // Destructure receipt data with fallback values
  const {
    receiptHeader: {
      companyName = "",
      companyTIN = "",
      address = "",
      phone = "",
      email = [],
      description = "",
    } = {},
    receiptDetails: {
      receiptNo = "",
      date = "",
      client = "",
      totalAmount = 0,
      chequeNo = "",
      balance = 0,
      amountInWords = "",
      paymentfor = "",
    } = {},
  } = receipt;

  const formattedDate = date
    ? new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(date))
    : "N/A";

  // Function to trigger print
  const handlePrint = () => {
    window.print();
  };

  return (
    // <div className="max-w-3xl mx-auto p-6">
    //   {/* Header */}
    //   <div className="text-center mb-4">
    //     <h1 className="text-xl font-bold uppercase">{companyName}</h1>
    //     <p className="text-xs">
    //       Plot 41 A/B, Nkrumah P.O. box 71141, Kampala Tel: 0752 / 0772 - 551508
    //       / 0782 - 631178
    //     </p>
    //     <p className="text-xs">Email: kevmark2000@gmail.com</p>
    //     <p className="text-xs">Dealers in General Merchandise</p>
    //   </div>

    //   {/* Receipt Title */}
    //   <div className="border-2 border-black p-2 mb-4 flex justify-between items-center">
    //     <h2 className="text-lg font-bold uppercase">Receipt</h2>
    //     <div className="text-right">
    //       <p>
    //         No: <span className="font-bold">{receiptNo}</span>
    //       </p>
    //       <p>
    //         Date: <span className="font-bold">{formattedDate}</span>
    //       </p>
    //     </div>
    //   </div>

    //   {/* Client Info */}
    //   <div className="mb-4">
    //     <p className="text-sm">
    //       M/s <span className="underline">{client}</span>
    //     </p>
    //   </div>

    //   {/* Received From */}
    //   <div className="mb-4">
    //     <p className="text-sm">
    //       Received with thanks from:{" "}
    //       <span className="underline">C/O MR. {client}</span>
    //     </p>
    //   </div>

    //   {/* Amount in Words */}
    //   <div className="mb-4">
    //     <p className="text-sm">
    //       The sum of shillings:{" "}
    //       <span className="underline">{amountInWords.toUpperCase()} ONLY</span>
    //     </p>
    //   </div>

    //   {/* Being Payment For */}
    //   <div className="mb-4">
    //     <p className="text-sm">
    //       Being payment for:{" "}
    //       <span className="underline">{paymentfor.toUpperCase()}</span>
    //     </p>
    //   </div>

    //   {/* Cash/Cheque No & Balance (Flex Display) */}
    //   <div className="flex justify-between mb-4">
    //     <div>
    //       <p className="text-sm">
    //         Cash/Cheque No:{" "}
    //         <span className="underline">{chequeNo || "N/A"}</span>
    //       </p>
    //     </div>
    //     <div>
    //       <p className="text-sm">
    //         Balance:{" "}
    //         <span className="underline">{balance.toLocaleString()}</span>
    //       </p>
    //     </div>
    //   </div>

    //   {/* Signatures */}
    //   <div className="flex justify-between mt-4">
    //     {/* Amount Box & With Thanks */}
    //     <div className="mb-4">
    //       <div className="border-2 border-black text-lg p-2 inline-block">
    //         SHS. {totalAmount.toLocaleString()}/=
    //       </div>
    //       <p className="mt-2 text-sm">With Thanks</p>
    //     </div>
    //     <div>
    //       <p className="text-sm">
    //         Signed:{" "}
    //         <span className="inline-block w-40 border-b border-black"></span>
    //       </p>
    //       <p className="mt-4 text-sm">For: KEVMARK INVESTMENTS LTD</p>
    //     </div>
    //   </div>

    //   {/* Print Button */}
    //   <button
    //     onClick={handlePrint}
    //     className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors print:hidden shadow-md"
    //   >
    //     Print
    //   </button>
    // </div>
    <div className="max-w-3xl mx-auto p-4 sm:p-6 bg-white border border-gray-300 rounded-lg shadow-sm my-8 text-xs sm:text-sm">
      {/* Header */}
      <div className="text-center mb-6 border border-gray-200 rounded-md p-3 sm:p-4">
        <h1 className="text-xl sm:text-2xl font-extrabold text-gray-900 uppercase tracking-tight">
          <img
            src="/images/logo.png"
            alt="Company Logo"
            className="h-20 w-20 mr-2 inline-block"
          />
          {companyName}
        </h1>
        <p className="text-xs sm:text-sm text-gray-600 mt-2 leading-relaxed">
          Plot 41 A/B, Nkrumah P.O. box 71141, Kampala Tel: 0752 / 0772 - 551508
          / 0782 - 631178
        </p>
        <p className="text-xs sm:text-sm text-gray-600">
          Email: kevmark2000@gmail.com
        </p>
        <p className="text-xs sm:text-sm text-gray-600 italic">
          Dealers in General Merchandise
        </p>
      </div>

      {/* Receipt Title */}
      <div className="border border-gray-200 rounded-md p-3 sm:p-4 mb-4 flex justify-between items-center">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 uppercase tracking-wide">
          Receipt
        </h2>
        <div className="text-right text-sm">
          <p className="text-gray-700">
            No: <span className="font-bold text-gray-900">{receiptNo}</span>
          </p>
          <p className="text-gray-700">
            Date:{" "}
            <span className="font-bold text-gray-900">{formattedDate}</span>
          </p>
        </div>
      </div>

      {/* Client Info */}
      <div className="mb-4 bg-gray-50 p-2 sm:p-3 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          M/s <span className="underline font-semibold">{client}</span>
        </p>
      </div>

      {/* Received From */}
      <div className="mb-4 p-2 sm:p-3 bg-gray-50 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          Received with thanks from:{" "}
          <span className="underline font-semibold">{client}</span>
        </p>
      </div>

      {/* Amount in Words */}
      <div className="mb-4 p-2 sm:p-3 bg-gray-50 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          The sum of shillings:{" "}
          <span className="underline font-semibold">
            {amountInWords.toUpperCase()} ONLY
          </span>
        </p>
      </div>

      {/* Being Payment For */}
      <div className="mb-4 p-2 sm:p-3 bg-gray-50 rounded-md border border-gray-200">
        <p className="text-xs sm:text-sm text-gray-700">
          Being payment for:{" "}
          <span className="underline font-semibold">
            {paymentfor.toUpperCase()}
          </span>
        </p>
      </div>

      {/* Cash/Cheque No & Balance */}
      <div className="flex flex-col sm:flex-row justify-between mb-4 border-b border-gray-200 pb-3">
        <p className="text-xs sm:text-sm text-gray-700">
          Cash/Cheque No:{" "}
          <span className="underline font-semibold">{chequeNo || "N/A"}</span>
        </p>
        <p className="text-xs sm:text-sm text-gray-700">
          Balance:{" "}
          <span className="underline font-semibold">
            {parseFloat(balance).toLocaleString()}
          </span>
        </p>
      </div>

      {/* Signatures and Amount Box */}
      <div className="flex flex-col sm:flex-row justify-between mt-4 gap-4">
        <div className="mb-4">
          <div className="border-2 border-gray-300 text-base sm:text-lg font-semibold text-gray-800 p-2 inline-block rounded-md">
            SHS. {parseFloat(totalAmount).toLocaleString()}/=
          </div>
          <p className="mt-2 text-xs sm:text-sm text-gray-700">With Thanks</p>
        </div>
        <div className="text-right">
          <p className="text-xs sm:text-sm text-gray-700">
            Signed:{" "}
            <span className="inline-block w-32 sm:w-40 border-b border-gray-300"></span>
          </p>
          <p className="mt-4 text-xs sm:text-sm text-gray-700">
            For: KEVMARK INVESTMENTS LTD
          </p>
        </div>
      </div>

      {/* Print Button */}
      <button
        onClick={handlePrint}
        className="w-full sm:w-auto bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200 print:hidden text-xs sm:text-sm shadow-md"
      >
        Print
      </button>
    </div>
  );
}

export default ViewReceipt;
